import { alpha } from "@mui/material";
import { grey } from "@mui/material/colors";

const styles = {
  mainContainer: {
    backgroundColor: "white",
    borderRadius: "1rem",
    width: "100%",
    height: "100%",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  secondaryContainer: {
    display: "flex",
    padding: "0px !important",
    gap: "12px",
  },
  sectionContainer: {
    color: grey[700],
    backgroundColor: alpha(grey[500], 0.15),
    borderRadius: "8px",
    padding: "10px 0px",
  },
  sectionDateContainer: {
    color: grey[700],
    backgroundColor: alpha(grey[500], 0.15),
    borderRadius: "8px",
    padding: "10px 0px",
    width: '140px',
  },
  title: {
    fontWeight: "bold",
  },
  data: {
    fontWeight: "bold",
  },
  date: {
    fontWeight: "bold",
  },
};

export default styles;
